module.exports = __webpack_public_path__ + "about-us-b998e096/video-c942510ba422e55ebbc79788086e1b55.svg";